const serializeSchema = {
    recordingStart: 'recording_start',
    recordingEnd: 'recording_end',
    recordingTime: 'recording_time',
    respiratoryEvents: 'respiratory_events',
    supineEvents: 'supine_respiratory_events',
    nonSupineEvents: 'nonsupine_respiratory_events',
    monitoringTime: 'monitoring_time',
    supineTime: 'supine_monitoring_time',
    nonSupineTime: 'nonsupine_monitoring_time',
    AHI: 'ahi',
    supineAHI: 'supine_ahi',
    nonSupineAHI: 'nonsupine_ahi',
    desaturations: 'desaturations',
    ODI: 'odi',
    avgHr: 'avg_heart_rate',
    minHr: 'min_heart_rate',
    maxHr: 'max_heart_rate',
    avgSpo2: 'avg_spo2',
    minSpo2: 'min_spo2',
    maxSpo2: 'max_spo2',
    validTime: 'valid_recording_time',

    // Ignored keys:
    // uprightTime
    // validTime
};

const deserializeSchema = {
    recording_start: {
        value: 'recordingStart',
        type: 'string',
    },
    recording_end: {
        value: 'recordingEnd',
        type: 'string',
    },
    recording_time: {
        value: 'recordingTime',
        type: 'number',
    },
    respiratory_events: {
        value: 'repspiratoryEvents',
        type: 'number',
    },
    supine_respiratory_events: {
        value: 'supineEvents',
        type: 'number',
    },
    nonsupine_respiratory_events: {
        value: 'nonSupineEvents',
        type: 'number',
    },
    monitoring_time: {
        value: 'monitoringTime',
        type: 'number',
    },
    supine_monitoring_time: {
        value: 'supineTime',
        type: 'number',
    },
    nonsupine_monitoring_time: {
        value: 'nonSupineTime',
        type: 'number',
    },
    ahi: {
        value: 'AHI',
        type: 'number',
    },
    supine_ahi: {
        value: 'supineAHI',
        type: 'number',
    },
    nonsupine_ahi: {
        value: 'nonSupineAHI',
        type: 'number',
    },
    desaturations: {
        value: 'desaturations',
        type: 'number',
    },
    odi: {
        value: 'ODI',
        type: 'number',
    },
    avg_heart_rate: {
        value: 'avgHr',
        type: 'number',
    },
    min_heart_rate: {
        value: 'minHr',
        type: 'number',
    },
    max_heart_rate: {
        value: 'maxHr',
        type: 'number',
    },
    avg_spo2: {
        value: 'avgSpo2',
        type: 'number',
    },
    min_spo2: {
        value: 'minSpo2',
        type: 'number',
    },
    max_spo2: {
        value: 'maxSpo2',
        type: 'number',
    },
    valid_recording_time: {
        value: 'validTime',
        type: 'number',
    },
};

/**
 * Converts the keys of an object to match what the server is expecting.
 * @param {*} original
 */
export function serialize(original) {
    return Object.keys(original).reduce((obj, curr) => {
        if (!serializeSchema[curr]) {
            return obj;
        }

        obj[serializeSchema[curr]] = original[curr] || 0;

        return obj;
    }, {});
}

function convertValue(type, value) {
    if (type === 'number' && typeof value === 'string') {
        return Number(value);
    }

    return value;
}

export function deserialize(original) {
    return Object.keys(original).reduce((obj, curr) => {
        if (!deserializeSchema[curr]) {
            return obj;
        }
        obj[deserializeSchema[curr].value] = convertValue(
            deserializeSchema[curr].type,
            original[curr]
        );

        return obj;
    }, {});
}
